import { Component } from '@angular/core';
import { Router, NavigationEnd } from '@angular/router';
import { ConsoleService } from './console.service';

@Component({
selector: 'app-root',
templateUrl: './app.component.html'
})

export class AppComponent {
title = 'ISMS';
hideFooter = false;
hiddenRoutes = ['/timeout','/login-page'];

constructor(private router: Router,private consoleservice:ConsoleService) {
this.router.events.subscribe(event => {
if (event instanceof NavigationEnd) {
    console.log('NavigationEnd:', event.urlAfterRedirects);
this.hideFooter = this.hiddenRoutes.some(route => 
event.urlAfterRedirects.includes(route)
);
}
});
this.consoleservice.disable();
// this.consoleservice.enable();

}
}